<template>
  <div ref="cell" class="grid-view__cell">
    <client-only>
      <div class="grid-field-date">
        <div ref="dateDisplay" class="grid-field-date__date">
          <SearchHighlightedText
            :text="getDate(field, value) || value"
            :search-term="searchTerm"
          />
        </div>
        <div
          v-if="field.date_include_time"
          ref="timeDisplay"
          class="grid-field-date__time"
        >
          <SearchHighlightedText
            :text="getTime(field, value)"
            :search-term="searchTerm"
          />
        </div>
        <div v-if="field.date_show_tzinfo" class="grid-field-date__tzinfo">
          <SearchHighlightedText
            :text="getCellTimezoneAbbr(field, value)"
            :search-term="searchTerm"
          />
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import readOnlyDateField from '@baserow/modules/database/mixins/readOnlyDateField'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldDate',
  components: { SearchHighlightedText },
  mixins: [readOnlyDateField],
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
